import axios from '../../utils/axios.js'
import cookie from '../../plugins/cookie.js';
var qs=require('qs');
const actions = {
    //登录
    async login({ commit, state }, val) {
        let params={
            username:val.username,
            password:val.password
        }
        let data = await axios.post('/admin/login/index',qs.stringify(params))
        return data.data
    },
    // 修改管理员密码
    async postEdit_password({ commit, state }, val) {
        let params={
            token:cookie.getcookiesInClient('token').toString(),
            old_password:val.old_password,
            new_password:val.new_password,
            new_password_re:val.new_password_re

        }
       let data = await axios.post('/admin/user.admin/edit_password',qs.stringify(params))
       return data.data
    },
    //我的菜单
    async my_menu({ commit, state }, val) {
        let params={
            token:cookie.getcookiesInClient('token').toString()||''
        }
        let data = await axios.post('/admin/index/index',qs.stringify(params))
        commit('updateMy_menu',data.data.data)
    },
     //查询轮播
     async getBanner({ commit, state }, val) {
        let params={
            crud:val.crud,
            bannerJson:val.bannerJson || null
        }
        console.log(params)
        let data = await axios.post('/do_oper_banner',qs.stringify(params))
        commit('updateBanner',data.data.data)
    },
    
}
export default actions


// WEBPACK FOOTER //
// ./src/store/indexData/actions.js